export const APP_SHELL_DIMENSIONS = Object.freeze({
  sidebarWidth: 184,
  collapsedSidebarWidth: 60,
  utilityBarHeight: 56,
  contentTopGap: 8,
});

export const getAppSidebarWidth = (collapsed) => (
  collapsed
    ? APP_SHELL_DIMENSIONS.collapsedSidebarWidth
    : APP_SHELL_DIMENSIONS.sidebarWidth
);

export const getAppCanvasBackground = (theme) => (
  theme.palette.mode === 'dark'
    ? theme.palette.background.default
    : 'linear-gradient(135deg, #f7fbff 0%, #edf5fb 55%, #f8fbfe 100%)'
);

export const buildAppMainSx = (navigationCollapsed) => {
  const sidebarWidth = getAppSidebarWidth(navigationCollapsed);

  return {
    minHeight: '100vh',
    ml: { xs: 0, md: `${sidebarWidth}px` },
    pt: `${APP_SHELL_DIMENSIONS.utilityBarHeight + APP_SHELL_DIMENSIONS.contentTopGap}px`,
    px: { xs: 1, sm: 1.5, xl: 2 },
    pb: 2,
    background: getAppCanvasBackground,
    transition: (theme) => theme.transitions.create('margin-left', {
      duration: theme.transitions.duration.shorter,
    }),
  };
};
